export const VSF_LOCALE_COOKIE = 'vsf-locale';
export const VSF_CURRENCY_COOKIE = 'vsf-currency';
export const VSF_COUNTRY_COOKIE = 'vsf-country';
export const VSF_STORE_COOKIE = 'vsf-store';
export const VSF_CHANNEL_COOKIE = 'vsf-channel';
